import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class BackOfANapkinMetricsComponent extends Component {
  @tracked metricWizardIsVisible = false;
  @tracked selectedMetric = null;
  @tracked selectedTargets = [];

  @action
  openMetricWizard() {
    this.metricWizardIsVisible = true;
  }

  @action
  closeMetricWizard() {
    this.metricWizardIsVisible = false;
  }

  @action
  openChartModal(metric) {
    this.selectedMetric = metric;
    const metricModel = metric?.content ?? metric;
    const targets = metricModel?.targets?.content ?? [];
    this.selectedTargets = targets;
  }

  @action
  closeChartModal() {
    this.selectedMetric = null;
    this.selectedTargets = [];
  }

  @action
  unlinkMetric(metric) {
    const targets = this.args.initiative.targets?.content;
    const target = targets.find(
      (_target) => _target.metric?.content?.id === metric.id,
    );
    target.destroyRecord();
    this.closeChartModal();
  }
}
